<template>
  <div class="text-right text-xs text-yapgray-500 dark:text-yapgray-200">
    {{ props.currentLength }}/{{ props.maxLength }}
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  currentLength: number;
  maxLength: number;
}>();
</script>
